// extracted by mini-css-extract-plugin
module.exports = {"resultsHeader":"ResultsHeader_resultsHeader__X--HL","resultsTitle":"ResultsHeader_resultsTitle__2pjlx"};